import { AutocompleteOptionType } from '@occc-app/design-system/components/LazyAutocomplete/types';
import { SegmentFragment } from '@occc/graphql';

export const mapRawSegmentResponseItemToAutocompleteOption = (
  segment: SegmentFragment,
): AutocompleteOptionType<SegmentFragment> => ({
  label: segment.name,
  description: segment.description,
  value: segment.uuid,
  _raw: segment,
});
